export const ORG_ADMIN = 'org-admin';
export const ORG_PREFIX = 'org-';
export const APPLICATION_ADMIN_SUFFIX = '-application-admin';
export const FUNCTION_CALL_DEFINITION_ADMIN_SUFFIX =
  '-function-call-definition-admin';
export const INDEX_ADMIN_SUFFIX = '-index-admin';
export const MODEL_ADMIN_SUFFIX = '-model-admin';
export const SUBSCRIPTION_ADMIN_SUFFIX = '-sub-admin';
export const USER_ADMIN_SUFFIX = '-user-admin';

export const USER_ADMIN_ROLES = [
  ORG_ADMIN,
  APPLICATION_ADMIN_SUFFIX,
  FUNCTION_CALL_DEFINITION_ADMIN_SUFFIX,
  INDEX_ADMIN_SUFFIX,
  MODEL_ADMIN_SUFFIX,
  SUBSCRIPTION_ADMIN_SUFFIX,
  USER_ADMIN_SUFFIX,
];
